module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"create-order":"Criar pedido","simulator":"Simulador de vendas"},"en-US":{"create-order":"Create order","simulator":"Sales simulator"}}')
  delete Component.options._Ctor
}
